<template>
	<li v-if="isWMAEnabledPartner" class="nav-link" role="none">
		<button
			:class="officeOpenInfo.active ? 'office-open' : 'office-closed'"
			@click.prevent="onScheduleClick"
		>
			<span>{{ officeOpenInfo.indicator }}</span>
		</button>
	</li>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { SETTINGS_SECTION_IDS } from '@/config/settingsConstants'

export default {
	computed: {
		isWMAEnabledPartner() {
			return this.partner?.wma_enabled && this.officeOpenInfo.visible
		},

		activePartnerId() {
			return this.partner?.id || this.$route.params.partner
		},

		...mapGetters({
			partner: 'partners/active',
			access: 'auth/hasOfficeManagerAccess',
			clarusAppType: 'partners/clarusAppType',
		}),
		...mapState('settings', {
			officeOpenInfo: state => state.officeOpenInfo,
		}),
	},

	methods: {
		async onScheduleClick() {
			if (!this.clarusAppType) {
				return this.$alert.error(
					'Please contact your system administrator.'
				)
			}

			if (!this.access) {
				return
			}

			const target = {
				name: 'app.settings',
				params: {
					partner: this.activePartnerId,
					section: SETTINGS_SECTION_IDS.OFFICE_HOURS,
				},
			}

			if (this.$route.name === 'app.settings') {
				if (
					this.$route.params.section !==
					SETTINGS_SECTION_IDS.OFFICE_HOURS
				) {
					await this.$router.replace(target).catch(() => {})
				}
				return
			}

			await this.$router.push(target).catch(() => {})
		},

		...mapActions('settings', {
			getOfficestatus: 'getOfficestatus',
		}),
	},

	name: 'OfficeStatus',

	watch: {
		'partner.id': {
			handler(newPartnerId, oldPartnerId) {
				if (newPartnerId !== oldPartnerId) {
					this.getOfficestatus()
				}
			},
			immediate: true,
		},
	},

	created() {
		this.getOfficestatus()
	},

	data() {
		return {
			intervalId: null,
		}
	},
}
</script>
